import { useEffect, useMemo } from 'react';
import { opportunitiesServices } from 'shared/services/opportunitiesServices';
import { useHeaderContentParser } from '../useHeaderContentParser';
import { ICastingAttributes } from 'shared/interfaces/ICasting';
import { ICastingRoleAttributes } from 'shared/interfaces/ICastingRole';
import { IMediumAttributes } from 'shared/interfaces/IMedium';

const { getRoleInfo } = opportunitiesServices();

export const useRoleContentParser = (roleId: string, isPublic?: boolean, castingRole?: ICastingRoleAttributes) => {
  const { data: role, isLoading: roleLoading, isSuccess, isLoadingError } = getRoleInfo(roleId, isPublic);
  const {
    ageType,
    roleName,
    union,
    rate,
    submitBy,
    work,
    fittingDate,
    age,
    gender,
    ethnicities,
    location,
    roleDescription,
    roleMediaCount,
    workingNote,
    ethnic_appearance,
    genders,
    talentSubmitBy,
  } = castingRole
    ? useHeaderContentParser(castingRole)
    : role && isPublic
      ? useHeaderContentParser(role.data.public_roles_on_notice_board)
      : {
          ageType: '-',
          roleName: '-',
          union: '-',
          rate: '-',
          submitBy: '-',
          work: '-',
          fittingDate: '-',
          age: '-',
          gender: '-',
          ethnicities: '-',
          location: '-',
          roleDescription: '-',
          roleMediaCount: 0,
          workingNote: '-',
          ethnic_appearance: '-',
          genders: [],
        };

  const roleData = useMemo(() => {
    if (castingRole) return castingRole;
    if (roleLoading) {
      return;
    } else {
      return role ? role?.data?.public_roles_on_notice_board : undefined;
    }
  }, [role, roleLoading]);

  const auditionNote = roleData?.audition?.note || '-';
  const wardrobeNote = roleData?.wardrobe || '-';
  const roleMedia = castingRole
    ? roleData?.sides.data.map((m) => m.attributes)
    : roleData?.medium_attachments || ([] as Array<IMediumAttributes>);
  const links = roleData?.reference_urls || [];

  return {
    roleMedia,
    wardrobeNote,
    auditionNote,
    roleLoading,
    ageType,
    roleName,
    union,
    rate,
    submitBy,
    talentSubmitBy,
    work,
    fittingDate,
    age,
    gender,
    ethnicities,
    location,
    roleDescription,
    roleMediaCount,
    workingNote,
    ethnic_appearance,
    genders,
    links,
  };
};
